var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 21,
    viewBox: "0 0 32 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.77778 21C1.27407 21 0.852148 20.832 0.512 20.496C0.170667 20.1612 0 19.7458 0 19.25C0 18.7542 0.170667 18.3388 0.512 18.004C0.852148 17.668 1.27407 17.5 1.77778 17.5H30.2222C30.7259 17.5 31.1479 17.668 31.488 18.004C31.8293 18.3388 32 18.7542 32 19.25C32 19.7458 31.8293 20.1612 31.488 20.496C31.1479 20.832 30.7259 21 30.2222 21H1.77778ZM1.77778 12.25C1.27407 12.25 0.852148 12.082 0.512 11.746C0.170667 11.4112 0 10.9958 0 10.5C0 10.0042 0.170667 9.58825 0.512 9.25225C0.852148 8.91742 1.27407 8.75 1.77778 8.75H30.2222C30.7259 8.75 31.1479 8.91742 31.488 9.25225C31.8293 9.58825 32 10.0042 32 10.5C32 10.9958 31.8293 11.4112 31.488 11.746C31.1479 12.082 30.7259 12.25 30.2222 12.25H1.77778ZM1.77778 3.5C1.27407 3.5 0.852148 3.33258 0.512 2.99775C0.170667 2.66175 0 2.24583 0 1.75C0 1.25417 0.170667 0.83825 0.512 0.50225C0.852148 0.167417 1.27407 0 1.77778 0H30.2222C30.7259 0 31.1479 0.167417 31.488 0.50225C31.8293 0.83825 32 1.25417 32 1.75C32 2.24583 31.8293 2.66175 31.488 2.99775C31.1479 3.33258 30.7259 3.5 30.2222 3.5H1.77778Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.02bea1a9a57dcb1bce6ef10cc782c356.svg";
export { ForwardRef as ReactComponent };